export const logToConsole = (...args) => {
  if (
    window?.console &&
    (localStorage.getItem('enable_maya_debugging') ||
      process.env.REACT_APP_API_ENV !== 'production')
  ) {
    console.log.apply(console, args)
  }
}
